export default "__VITE_ASSET__CeIuj6u$__"